<template>
  <div class="d-flex flex-column flex-root">
    <div class="page d-flex flex-row flex-column-fluid">
      <v-aside />
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <v-header />
        <div class="content d-flex flex-column flex-column-fluid" id="kt_content">
          <div id="kt_content_container" class="container-fluid">
            <router-view />
          </div>
        </div>
        <v-footer />
      </div>
    </div>
  </div>
  <notifications position="top right" :pauseOnHover="true"/>
</template>

<script>
import VToolbar from '@/components/MainWidgets/VToolbar.vue'
import VHeader  from '@/components/MainWidgets/VHeader'
import VAside   from '@/components/MainWidgets/VAside'
import VFooter  from '@/components/MainWidgets/VFooter'
import crypto   from '@/helpers/crypto'

export default {
  name: 'MainLayout',
  components: {VToolbar, VHeader, VAside, VFooter},
  mounted() {
    if (localStorage.getItem('user')) {
      this.$store.dispatch("userRequest", JSON.parse(crypto.decrypt(localStorage.getItem('user'))));
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || 'Energo';
      }
    },
  }
}
</script>

<style scoped>

</style>